import api from "./api";

export async function createOrder({

    outletUid,

    amount,

}) {

    const response = await api.post(

        "/api/v1/payments/create-order",

        {

            outletUid,

            amount,

        }

    );

    return response.data;

}

export async function verifyPayment({

    razorpayPaymentId,

    razorpayOrderId,

    razorpaySignature,

}) {

    const response = await api.post(

        "/api/v1/payments/verify",

        {

            razorpayPaymentId,

            razorpayOrderId,

            razorpaySignature,

        }

    );

    return response.data;

}

export async function createAuthorizationTransaction(data) {

    const response = await api.post(

        "/api/v1/payments/create-authorization-transaction",

        data

    );

    return response.data;

}

export async function verifyAuthorizationTransaction(data) {

    const response =
        await api.post(

            "/api/v1/payments/verify-authorization-transaction",

            data

        );

    return response.data;

}

export async function updateAutoTopupSettings(data) {

    const response =
        await api.patch(

            "/api/v1/payments/update-autopay",

            data

        );

    return response.data;

}

export async function disableAutoTopup(
    outletUid
) {

    const response =
        await api.patch(

            "/api/v1/payments/disable-autopay",

            {

                outletUid,

            }

        );

    return response.data;

}